import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Title from '../../../components/Title';
import Breadcrumbs from '../../../components/Breadcrumbs';
import MultimediaFilter from './dataGrid/MultimediaFilter';
import MultimediaDataGrid from './dataGrid/MultimediaDataGrid';
import * as Selectors from '../redux/multimediaSelectors';
import * as Actions from '../redux/multimediaActions';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings';

const breadcrumbs = [
  {
    label: 'multimedia.list',
    to: null,
  },
];

interface MultimediaListProps {
  handleAssetChoose?: (val: string) => void;
}

const MultimediaList: FC<MultimediaListProps> = ({ handleAssetChoose }) => {
  const { t } = useTranslation();
  const apiRequestState = useSelector(Selectors.apiAllMultimediaRequestState);
  const apiRequestError = useSelector(Selectors.apiAllMultimediaRequestError);

  return (
    <>
      <SnackbarSettings
        hideSuccessMessage={true}
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiAllMultimediaRequestState}
      />
      <Title>{t('multimedia.list')}</Title>
      <Breadcrumbs title="multimedia.list" links={breadcrumbs} hide />
      <MultimediaFilter />
      <MultimediaDataGrid handleAssetChoose={handleAssetChoose} />
    </>
  );
};

export default MultimediaList;
